import { createShallowStore, createStore } from '@frontend/store';

interface CalendarV3Store {
  calendarDate: string; // MM/DD/YYYY

  calendarLocationIds: string[];
  calendarProviderIds: string[];
  calendarApptTypeIds: string[];
  calendarApptStatus: string;
  hasCalendarFilters: boolean; // derived based on calendarProviderIds, calendarApptTypeIds, and calendarApptStatus

  setCalendarDate: (calendarDate: string) => void;
  setCalendarLocationIds: (locationIds: string[], shouldResetFilters?: boolean) => void;
  setCalendarFilters: (filters: { providerIds: string[]; apptTypeIds: string[]; apptStatus: string }) => void;
}

const useCalendarV3Store = createStore<CalendarV3Store>(
  (set) => ({
    calendarDate: '', // default to empty string, will be set to today's date in the component based on location timezone

    // filter related info
    calendarLocationIds: [],
    calendarProviderIds: [],
    calendarApptTypeIds: [],
    calendarApptStatus: '',
    hasCalendarFilters: false,

    setCalendarDate: (calendarDate) => set({ calendarDate }),
    setCalendarLocationIds: (locationIds, shouldResetFilters) => {
      set({
        calendarLocationIds: locationIds,
        ...(shouldResetFilters
          ? {
              calendarProviderIds: [],
              calendarApptTypeIds: [],
              calendarApptStatus: '',
              hasCalendarFilters: false,
            }
          : undefined),
      });
    },

    setCalendarFilters: ({ providerIds, apptTypeIds, apptStatus }) => {
      set({
        calendarProviderIds: providerIds,
        calendarApptTypeIds: apptTypeIds,
        calendarApptStatus: apptStatus,
        hasCalendarFilters: !!(providerIds.length || apptTypeIds.length || apptStatus),
      });
    },
  }),
  {
    name: 'calendar-v3-store',
  }
);

export const useCalendarV3ShallowStore = createShallowStore<CalendarV3Store>(useCalendarV3Store);
